import { Extension } from "@tiptap/core";
import type { Node as ProseMirrorNode } from "prosemirror-model";
import { Plugin, PluginKey } from "prosemirror-state";
import { Decoration, DecorationSet } from "prosemirror-view";

export const HighlightExtension = Extension.create({
	name: "customHighlight",

	addProseMirrorPlugins() {
		return [
			new Plugin({
				key: new PluginKey("customHighlight"),
				state: {
					init() {
						return DecorationSet.empty;
					},
					apply(tr, oldSet) {
						oldSet.map(tr.mapping, tr.doc);
						const regex = /\{\{(.*?)\}\}/g;
						const decorations: Decoration[] = [];

						tr.doc.descendants((node: ProseMirrorNode, pos: number) => {
							if (node.isText) {
								let match: RegExpExecArray | null;
								match = regex.exec(node.text || "");
								while (match !== null) {
									const start = pos + match.index;
									const end = start + match[0].length;

									// Add decoration for the content inside braces
									decorations.push(
										Decoration.inline(start + 2, end - 2, {
											class: "custom-highlight",
										}),
									);

									// Add decorations to hide the braces
									decorations.push(
										Decoration.inline(start, start + 2, {
											class: "hide-highlight-brace",
										}),
									);
									decorations.push(
										Decoration.inline(end - 2, end, {
											class: "hide-highlight-brace",
										}),
									);

									match = regex.exec(node.text || "");
								}
							}
						});

						return DecorationSet.create(tr.doc, decorations);
					},
				},
				props: {
					decorations(state) {
						return this.getState(state);
					},
				},
			}),
		];
	},
});
